import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { 
  IconButton, 
  Tooltip, 
  Dialog, 
  DialogTitle, 
  DialogContent,
  DialogActions,
  Button
} from '@material-ui/core';
import { People as PeopleIcon } from '@material-ui/icons';
import UserClientRoles from 'components/UserClientRoles';
import { Lock as LockIcon } from '@material-ui/icons';

const ManageClientRolesButton = ({ item }) => {
  const [isOpen, setIsOpen] = useState(false);

  // Do not render the button for global admin users
  if (Array.isArray(item.roles) && item.roles.includes('admin')) {
    return null;
  }

  return (
    <>
      <Tooltip title="Manage Client Roles">
        <IconButton
          onClick={() => setIsOpen(true)}
          size="small"
        >
          <PeopleIcon />
        </IconButton>
      </Tooltip>

      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            maxHeight: '80vh',
            overflow: 'hidden'
          }
        }}
      >
        <DialogTitle>
          {`Client Role Assignments - ${item.name} (${item.email})`}
        </DialogTitle>
        <DialogContent dividers style={{ padding: 0, overflow: 'hidden' }}>
          {Array.isArray(item.roles) && item.roles.includes('admin') && (
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              background: '#e8f4fd',
              color: '#0b5cad',
              padding: '12px 16px',
              borderBottom: '1px solid #cfe4fb'
            }}>
              <LockIcon fontSize="small" />
              <span>This user has Global Admin access - full permissions across all clients.</span>
            </div>
          )}
          <UserClientRoles userId={item._id} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsOpen(false)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

ManageClientRolesButton.propTypes = {
  item: PropTypes.object.isRequired,
};

export default ManageClientRolesButton;
